import { render, staticRenderFns } from "./FAQMentor.vue?vue&type=template&id=2b755d0f&scoped=true"
import script from "./FAQMentor.vue?vue&type=script&lang=js"
export * from "./FAQMentor.vue?vue&type=script&lang=js"
import style0 from "./FAQMentor.vue?vue&type=style&index=0&id=2b755d0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b755d0f",
  null
  
)

export default component.exports